import type {Moment} from 'moment-timezone';

const numericFormat = (date: Moment) => {
    return date.clone().format('M/D');
};

const textFormat = (date: Moment) => {
    return date.clone().format('MMM D');
};

export {numericFormat, textFormat};
